import clsx from 'clsx';
import React, { ReactNode, useState } from 'react';

import { resolveImageUrl } from '~/utils/resolve-image-url/resolveImageUrl';

import styles from './ThemeLogoIcon.module.scss';

export const themeLogoIconStyles = styles;

export const ThemeLogoIcon = ({
  name,
  logo_url,
  isCondensed = false,
  fallbackIcon,
  size,
  isDisabled,
}: {
  name: string;
  logo_url?: string;
  isCondensed?: boolean;
  fallbackIcon?: ReactNode;
  size?: number;
  isDisabled?: boolean;
}) => {
  const [imageError, setImageError] = useState(false);
  const dimensionStyle =
    size !== undefined ? { width: size, height: size } : undefined;

  return logo_url && !imageError ? (
    <img
      data-theme-overview-logo
      src={resolveImageUrl(logo_url)}
      alt=""
      onError={() => setImageError(true)}
      className={clsx(
        styles.logoImg,
        !size &&
          (isCondensed ? styles.logoImgCondensed : styles.logoImgExpanded),
        isDisabled ? styles.logoImgDisabled : styles.logoImgEnabled
      )}
      style={dimensionStyle}
    />
  ) : (
    <>
      {fallbackIcon ?? (
        <div
          data-theme-overview-logo
          className={clsx(
            styles.logoFallback,
            isCondensed
              ? styles.logoFallbackCondensed
              : styles.logoFallbackExpanded,
            isDisabled
              ? styles.logoFallbackDisabled
              : styles.logoFallbackEnabled
          )}
          style={dimensionStyle}
        >
          {name.charAt(0)}
        </div>
      )}
    </>
  );
};
